var ProductDirectiveBaseController = /** @class */ (function () {
    function ProductDirectiveBaseController($scope, $transclude, $element) {
        this.$scope = $scope;
        this.$transclude = $transclude;
        this.$element = $element;
    }
    ProductDirectiveBaseController.prototype.$onInit = function () {
        var _this = this;
        this.$scope.pId = Number(this.$scope.pId);
        if (!isNaN(this.$scope.pId)) {
            this.updateFromProduct(this.$scope.pId);
        }
        this.$scope.$watch('pId', function (newValue, oldValue) {
            var productId = Number(newValue);
            if (newValue === oldValue || isNaN(productId)) {
                return;
            }
            _this.updateFromProduct(productId);
        });
    };
    ProductDirectiveBaseController.prototype.transclude = function () {
        var _this = this;
        this.$transclude(this.$scope, function ($clonedElement) {
            if (!$clonedElement) {
                return;
            }
            _this.$element
                .empty()
                .append($clonedElement);
        });
    };
    return ProductDirectiveBaseController;
}());
export { ProductDirectiveBaseController };
